<script>

</script>
<div class='row justify-content-center mt-5'>
    <div class='col-sm-12 col-md-8 col-lg-6'>
        <div class='card mb-3'>
            <div class='card-header'>
                Thanks
            </div>
            <div class='card-body'>
                <h4>
                    Thanks for your Booking
                </h4>
                <p>
                    Check your inbox for a confirmation of your booking.
                </p>
                <p>
                    We look forward to seeing you on your Course.
                </p>
            </div>
        </div>
    </div>
</div>